const Form010SC = {
    stepName: {
        ImportantNotes: "事项",
        FormExpired: "事项",
        Application: "申请讯息",
        AcademicDetails: "学业概况和校内服务",
        LanguageProficiency: "语言能力,兴趣及才艺",
        TravelingExperience: "旅游经验",
        FurtherInformation: "其他资料",
        Declaration: "声明",
        Consent: "家长 / 监护人同意书",
        FormA: "甲部",
        FormB: "推荐",
        SectionB: "乙部 及 丙部",
        SectionD: "丁部",
        SectionE: "戊部 及 己部",
        SectionG: "庚部",
        SectionH: "辛部 及 壬部",
        SectionJ: "癸部 及 事项",
        Confirmation: "确认",
    },
    title: {
        note: "注意",
        collectionPersonal: "个人资料收集",
        languageProficiency: "(D) 语言能力",
        employment: "工作",
        personalParticulars: "(A) 个人资料",
        hkPersonTitle: "居港联络人资料",
        exchangeProgramme: "交流计划",
        exchangeProgrammeTitle: "你过去曾否带领其他学生交流计划？",
        exchangeProgrammeTableTitle: "若有，请提供有关资料",
        InterestsAndHobbies: "兴趣及嗜好",
        InterestsAndHobbiesTableTitle:
            "请填上你的兴趣及嗜好，若有需要，可附上有关证明：",
        part2: "第二部分",
        part2title: "推荐 - 由提名学校的校长填写",
        undertakeTitle: `本人明白学生代表及随团教师的选拔是独立处理的。一旦获提名学生入选，不论同样获本人提名参加计划的教师（如有）是否获选，本人承诺让该生于{{undertakeDate}}期内参加交流团。本人将敦促他 / 她出席所有活动及在外访期间敦品励行。`,
        academicDetails: "(B) 学业概况",
        responsibilitiesInSchool: "(C) 校内服务",
        TravelingExperience: "(F) 旅游经验",
        FurtherInformation: "(H) 其他资料",
        Declaration: "(I) 声明",
        Consent: "(J) 家长 / 监护人同意书",
        interestsTalents: "(E) 兴趣及才艺",
        questions: "(G) 请回答下列问题",
        consentTitle: `本人同意敝子弟参加「计划」，并承诺一旦他 / 她获选，定当督促他 / 她履行(I)段列出的责任及义务。`,
    },
    label: {
        japanese: "日语",
        english: "英文",
        putonghua: "普通话",
        proficiencyOptions: {
            fluent: "流利",
            canExpress: "略懂",
            cannotSpeak: "不懂",
        },
        remarks: "备注",
        canSpeakJapanese: "(a) 语言程度",
        everLearntJapanese: "(b) 你有否进修日语课程？",
        outstandingPerformance:
            "(c) 在普通话及／或英语方面，你有否突出表现？(如考获国家语委普通话水平测试二级乙等或以上成绩、国际英语水平测试(IELTS)整体成绩为6级或以上)",
        outstandingPerformance1: "国际英语水平测试(IELTS)整体成绩为6级或以上)",
        everLearntJapaneseOptions: {
            yes: "有",
            no: "没有",
        },
        learntJapaneseNote: "若有，请提供有关资料，并附上有关证明文件副本：",
        courseName: "课程名称",
        attainedLevel: "获取程度",
        startDate: "开始日期",
        completeDate: "完结日期",
        schoolName: "学校名称",
        schoolAddress: "学校地址",
        schoolTel: "电话",
        schoolFax: "传真",
        positionHeld: "职位",
        positionHeldOptions: {
            assistantPrincipal: "副校长",
            seniorTeacher: "主任",
            teacher: "教师",
        },
        presentSchoolDate: "到校任教的日期",
        presentPostDate: "出任现职的日期",
        taughtTitle: "本学年任教高中的科目",
        taughtSubject: "任教科目",
        taughtLevel: "任教级别",
        taughtRemarks: "附注",
        headTitle: "非教学工作 （班主任 / 学会顾问 / 课外活动统筹等）",
        headPosition: "职位",
        natureOfDuty: "职务",
        period: "期间",
        headRemarks: "附注",
        experienceTitle: "其他工作经验 （包括非教学经验及海外的工作经验）",
        instituteName: "学校 / 院校机构",
        nameRemark: "姓名(请依香港特别行政区护照所示填写)",
        englishName: "英文",
        chineseName: "中文",
        chineseCodeName: "姓名(中文姓名电码)",
        birthDate: "出生日期",
        birthPlace: "出生地点",
        sex: "性别",
        hkIDNo: "香港身份证号码",
        homeAddress: "住址",
        photoAttachment: "请上载照片",
        homeTel: "联络电话号码",
        mobilePhone: "流动电话",
        eMailAddress: "电邮地址",
        faxNo: "传真号码",
        hkSARPassportNumber: "你是否持有有效的香港特别行政区护照？",
        expiryDate: "届满日期",
        issueDate: "签发日期",
        sexOption: {
            Male: "男",
            Female: "女",
        },
        hkPersonEnName: "姓名(英文)",
        hkPersonCnName: "姓名(中文)",
        hkPersonRelationship: "与获提名人的关系",
        hkPersonAddress: "地址",
        hkPersonHomeTel: "联络电话号码",
        hkPersonMobliePhone: "流动电话",
        hkPersonEmail: "电邮地址",
        hkPersonFax: "传真",
        exchangeProgrammePeriod: "期间",
        exchangeProgrammeHostingOrganization: "主办机构",
        exchangeProgrammePlace: "曾经到访的地区 / 国家",
        exchangeProgrammePurpose: "该行目的",
        exchangeProgrammeHostingRole: "你的职责",
        interestsOrHobbies: "兴趣 / 嗜好",
        achievements: "成绩（相关纪录，如有）",
        gotFirstAidTraining: "你过去曾否接受急救训练？",
        gotFirstAidTrainingTitle:
            "若有，请列出急救证书的有效日期，并附上有关的证明。",
        firstAidCertificateExpiryDate: "急救证书的有效日期(日 / 月 / 年)",
        trainUpStudentDelegatesArea:
            "请列出你能训练学生代表的范畴，例如：简单日语、演讲、合唱等",
        supportingApplicationInformation:
            "请列出其他有助你申请的资料，如曾任日语翻译等",
        attendActivities:
            "(a) 一旦获选，你能否出席安排于星期六、日早上 / 下午及週日午后 / 黄昏举行的活动？",
        attendActivitiesOptions: {
            yes: "可以",
            no: "不可以",
            notSure: "不肯定",
        },
        nomineeName: "获提名人姓名",
        nominationReasons: "本人的提名是基于下列原因",
        principalName: "校长姓名",
        contactTel: "联络电话号码",
        academicDetailsSchoolName: "学校名称",
        academicDetailsSchoolAddress: "学校地址",
        academicDetailsLevel: "年级",
        electiveSubject: "选修科目：",
        examinationReports: "请夹附中四最后两次考试成绩表副本。",
        responsibilitiesPeriod: "期间",
        studentUnion: "学生会/ 学会/ 会社",
        post: "岗位",
        experiencesBenefit: "上述经验对你有何裨益？",
        examinationName: "考试 / 比赛名称",
        levelAttained: "获取程度",
        completionDate: "完成日期 / 获奖日期",
        interestsOrTalents: "兴趣 / 才艺",
        interestsOrTalentsAchievements: "成绩（相关纪录，如有）",
        interestsOrTalentsAttachment:
            "请填上你的兴趣及才艺，并附上有关证明文件副本，如有：",
        countryVisited: "前往国家",
        travelingPeriodFrom: "由",
        travelingPeriodTo: "至",
        travelingTimes: "次数 (截至{{travelingTimes}})",
        travelingPurpose: "目的（例如：观光、交流、服务）",
        interestedProgramme: "(a) 你为何有兴趣参加「计划」？",
        expectProgramme: "(b) 你期望从「计划」中可获得甚么？",
        shareExperience: "(c) 你打算于外访后如何与同侪分享此行的体验？",
        appliedActivities:
            "(b) 你有否申请 / 获取录参加于{{appliedTime}}期间举行的其他交流计划及 / 或类近的活动？",
        provideInformation: "(i) 若有，请提供有关资料。",
        appliedActivitiesPeriod: "期间",
        appliedActivitiesProgramme: "活动名称",
        appliedActivitiesOrganization: "举办机构",
        appliedActivitiesRemarks: "备注",
        appliedActivitiesRemarksOptions: {
            underApplication: "正在申请",
            admitted: "已获取录",
        },
        giveUpProgramme:
            "(ii) 如果你获选参加「计划」，你是否会／可以放弃于同一时期举行的交流计划？",
        giveUpProgrammeOptions: {
            yes: "是",
            no: "否",
        },
        parentName: "家长 / 监护人姓名",
        nomineeRelationship: "与获提名人的关系",
        parentSign: "家长 / 监护人签署",
        pleaseContact: "如对是次提名有任何查询，可联络",
        teacherName: "负责老师姓名",
        teacherSexOptions: {
            Mr: "先生",
            Ms: "女士",
        },
        nomineeSign: "获提名人签署",
        approverEmailAddress: "电邮地址",
        hasPassNoTips: "若有，请提供香港特别行政区护照届满日期",
        passNoExpireDate: "香港特别行政区护照届满日期(日／月／年)",
    },
    options: {
        hasPassNoOp: {
            yes: "有",
            no: "没有",
        },
    },
    errorMsg: {
        englishName: "英文姓名",
        chineseName: "中文姓名",
        appliedActivitiesPeriod: "请输入2025年11月至12月之间的日期",
    },
    note: {
        note1: "(a) 学校须于<b>{{deadline}}</b>递交提名表格及相关文件。学校可透过统一登入系统(https://clo.edb.gov.hk/)递交填妥的提名表格，并上载所需证明文件。",
        note2: "(b) 本表格内的资料将用于处理「计划」的申请。",
        note3: `(c) 获提名人须上载照片壹张于本表格上。`,
        note4: "(d) 如未能提供所需资料／文件，可能引致申请不获接纳。",
        note5: "(1)	教育局会用本表格所载的个人资料，作以下其中一种或多种用途：",
        note6: "(a)	办理 21 世纪东亚青少年大交流计划的申请；及",
        note7: "(b) 进行有关的研究及编制统计资料，以便规划有关的教育服务。",
        note8: "(2) 你必须在本表格上填写个人资料，如不能提供这些资料，申请的处理工作及结果或会受影响。",
        note9: "(3) 本表格所搜集的个人资料，或会向其他政府部门 / 决策局或接待机构披露，作上文所述用途。",
        note10: "(4) 根据《个人资料（私隐）条例》第 18 和 22 条及附表 1 第 6 原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        note11: `(5) 如欲查询有关本表格所搜集的个人资料，包括要查阅及改正资料事宜，请向教育局延伸支援计划组提出，地址为
        香港湾仔皇后大道东 213 号胡忠大厦 11 楼 1141 室 （电话号码：2892 6663）。`,
        note12: "(a) 本人声明，上述所填报的资料均属真确无讹。",
        note13: "(b) 本人承诺一旦获选，定当：",
        note14: "作为学生代表，敦品励行、严守纪律，并履行一切相关的责任及义务；",
        note15: "出席所有出发前的会议、训练、简介会及綵排活动等，并明白一旦缺席上述任何活动，作为代表团成员的资格可被取消；",
        note16: "制订有关香港的资料以备向接待机构讲解；",
        note17: "在外访期间参与才艺表演；",
        note18: "于外访结束后完成此行的个人评估表；",
        note19: "于外访结束后一个半月内完成有关交流成果的小组报告；及",
        note20: "应教育局及 / 或赞助机构的邀请或要求，出席相关活动。",
        note21: "填妥的提名表格须连同下列文件一并提交：",
        note22: "(a) 正面半身近照一张；",
        note23: "(b) 中四最后两次考试成绩表副本；",
        note24: "(c) 通晓 / 学习日语的证明文件副本，如有；及",
        note25: "(d) 普通话及 / 或英语有突出表现的证明文件副本，如有。",
    },
    button: {
        submit: "填写表格",
        sign: "家长签署",
    },
};

export default Form010SC;

